// src/config/api.js
const API_BASE_URL = process.env.REACT_APP_BACK_URL || 'http://localhost:8080/api'

export const categoriesAPI = {
  getCategories: async () => {
    const response = await fetch(`${API_BASE_URL}/categories`)
    if (!response.ok) throw new Error('Error al obtener categorías')
    return response.json()
  },

  getProductsByCategory: async (category, page = 1, limit = 10) => {
    let url = `${API_BASE_URL}/categories/products?page=${page}&limit=${limit}`
    
    if (category) {
      url += `&category=${encodeURIComponent(category)}`
    }
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener productos')
    return response.json()
  }
};

export default API_BASE_URL